module.exports = __webpack_public_path__ + "img/search_icon.f4309ea8.svg";